import React, { useEffect, useState } from 'react';

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Typography
} from "@mui/material";
import Bottom from "../Bottom";
import Top from "../Top";
import Circle from "../../components/CircleProgress";
import BarChart from "../../components/BarChart";
import HistoryInput from "../../components/HistorySportsInput";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import calendarsports from "../../assets/icon/calendarsports.gif";
import * as util from "../../utils/util";
import api from "../../utils/api";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import HistorySliderInput from "../../components/HistorySliderInput";
import hoistoryStore from "../../store/historyStore";
import VerifiedIcon from '@mui/icons-material/Verified';


const params = {
  token: '',
  from: '',
  to: '',
  target: ''
}

const initTargetExercise = {
  calory: 0,
  target_calory: 0,
  exercise: [{
    calory: '', time: '', type: ''
  }]
}

const HistoryBurnKcal = () => {
  const storeData: any = hoistoryStore();
  const [targetDate, setTargetDate] = React.useState('');
  const [targetExercise, setTargetExercise] = React.useState(initTargetExercise);
  const [series, setSeries] = React.useState([
    { dataKey: 'calory', label: '운동량', valueFormatter: (value: number | null) => `${value}mm`, stack: 'total' }
  ]);
  const [dataset, setDataset] = React.useState([{ target: 0, calory: 0, month: '' }]);
  const [dayValue, setDayValue] = useState(0);
  const [memberWeight, setMemberWeight] = useState(0);

  useEffect(() => {
    setExerciseData();
  }, [dayValue]);

  function setExerciseData() {
    storeData.setSelectedExerciseList([]);
    // 운동 정보 조회
    params.token = localStorage.getItem('token') || '';
    params.from = util.getDateByCustom('yyyyMMdd', dayValue - 7);
    params.to = util.getDateByCustom('yyyyMMdd', dayValue);
    params.target = util.getDateByCustom('yyyyMMdd', dayValue);

    api.get(`app/api/v1/AP_002_003?token=${params.token}&from=${params.from}&to=${params.to}&target=${params.target}`).then(res => {
      if (res.data.result_code === '0') {
        setTargetDate(params.target);
        setTargetExercise(res.data.result_data.target);
        setSeries(series);
        let tempArr = [];
        for (let item of res.data.result_data.data.calory_v2) {
          let obj = { target: 0, calory: 0, month: '' };
          obj.month = item.date;
          obj.calory = item.calory;
          tempArr.push(obj);
        }
        setDataset(tempArr.reverse());

        const target = res.data.result_data.target;
        api.get('permission/getProfile').then((res: any) => {
          setMemberWeight(res.data.weight);
          if (target.exercise.length > 0) {
            const list = target.exercise.map((v: any) => true ? { ...v, mets: util.getMetsByCalory(Number(v.time / 60), Number(v.calory), Number(res.data.weight)) } : v);
            storeData.setSelectedExerciseList(list);
          }
        }).catch(function (error: any) {
          console.log(error)
        });
      }
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 목표 운동량 저장
  function saveTargetExercise(value: any) {
    const saveParams = { date: '', targetExercise: '' };
    saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
    saveParams.targetExercise = value;

    api.post(`app/api/v1/AP_002_010`, saveParams).then(res => {
      setExerciseData();
    }).catch(function (error) {
      console.log(error)
    });
  }

  // 운동 저장
  async function handleComplete(value: any) {
    if (util.strNull(window.localStorage.userCusID) !== '') {
      let saveParams = { date: '', calory: '', type: '', time: '' };
      saveParams.date = targetDate.slice(0, 4) + '-' + targetDate.slice(4, 6) + '-' + targetDate.slice(6, 8);
      saveParams.type = storeData.selectedExerciseList.map((v: any) => v.type).join('--');
      saveParams.time = storeData.selectedExerciseList.map((v: any) => v.time).join('--');
      saveParams.calory = storeData.selectedExerciseList.map((v: any) => util.getCaloryByMets(v.time / 60, v.mets, memberWeight)).join('--');

      api.post(`app/api/v1/AP_002_007`, saveParams).then(res => {
        setExerciseData();
        storeData.setSelectedExerciseList([]);
      }).catch(function (error) {
        console.log(error)
      });
    }
  }



  return (
    <Stack sx={{ width: '100%', minWidth: 320, background: '#F1F2F4', pb: 12, pl: 2, pr: 2, boxSizing: 'border-box' }} spacing={6}>
      <Top title="운동 기록" />

      <Grid sx={{ bgcolor: '#F1F2F4', p: 0, width: '100%', minHeight: 500 }}>
        <Box>
          <Typography component="div" sx={{ fontSize: 20, color: '#555', m: 4, mb: 0, textAlign: 'center', fontWeight: 700 }}>
            <ArrowLeftIcon onClick={() => setDayValue((prev) => prev - 1)} sx={{ verticalAlign: 'text-bottom' }} />
            {targetDate.slice(0, 4) + '.' + targetDate.slice(4, 6) + '.' + targetDate.slice(6, 8)}
            <ArrowRightIcon onClick={() => setDayValue((prev) => prev + 1)} sx={{ 'display': dayValue < 0 ? 'inline-block' : 'none', verticalAlign: 'text-bottom' }} />
          </Typography>

          <Stack direction={'row'} justifyContent={'center'} sx={{ m: '20px 0', p: 1, bgcolor: '#fff', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Grid sx={{
              '& .CircleChart .MuiGauge-root': { width: '130px', height: '130px' },
              '& .CircleChart .circleText': { fontSize: 24, },
              '& .MuiGauge-valueArc': {
                fill: '#ff5454 !important',
              },
            }}>
              <Circle progress={{ goal: targetExercise.target_calory, value: targetExercise.calory }} />
            </Grid>

            <Stack justifyContent={'center'} sx={{ m: 'auto', }}>
              <Avatar alt="" src={calendarsports} sx={{ m: 'auto', width: '60px', height: '60px' }} />
            </Stack>

            <Stack direction={'row'} alignItems={'center'} sx={{ ml: 'auto', mr: 2 }}>
              <Stack direction={'column'} sx={{ ml: 'auto' }}>
                <Typography component="div" sx={{ fontSize: 35, color: '#ff5454', fontWeight: 700 }}>
                  {util.formatComma(Math.round(targetExercise.calory))}
                </Typography>
                <Typography component="span" sx={{ fontSize: 20, color: '#999', mb: 0, textAlign: 'right' }}>
                  {util.formatComma(targetExercise.target_calory)}
                </Typography>
              </Stack>
              <Typography component="div" sx={{ fontSize: 18, color: '#777', ml: 1, mb: 2 }}>
                kcal
              </Typography>
            </Stack>
          </Stack>

          <Accordion defaultExpanded sx={{ borderRadius: '15px', position: 'static' }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{
                '&#panel1a-header': { minHeight: '55px' },
                '& .MuiAccordionSummary-content.Mui-expanded': { m: 0 }
              }}
            >
              <Typography sx={{ fontSize: 16, color: '#555', fontWeight: 700, }}>운동 기록</Typography>
            </AccordionSummary>
            <Divider />

            <AccordionDetails>

              <List sx={{ p: 0 }}>

                {targetExercise.exercise.map((item: any, index: any) => (
                  <ListItem key={index} className='exerciseList'
                    sx={{
                      borderBottom: '1px solid #ddd',
                      '&.exerciseList:last-child': { borderBottom: 'none' }
                    }}>
                    <Grid container alignItems="center">
                      <Grid xs={8} justifyContent={'center'}>
                        <Typography component="div" sx={{ fontSize: 14, color: '#555', fontWeight: 700 }}>{item.type}</Typography>
                        <Typography component="div" sx={{ fontSize: 12, color: '#777', }}>{item.time}분</Typography>
                      </Grid>
                      <Grid xs={3}>
                        <Typography component="div" sx={{ fontSize: 16, color: '#333', fontWeight: 700, textAlign: 'right', mr: 1 }}>{util.formatComma(item.calory)}</Typography>
                      </Grid>
                      <Grid xs={1}>
                        <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>Kcal</Typography>
                      </Grid>
                    </Grid>
                  </ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>

          <Grid container justifyContent="center" alignItems="center" >
            <HistoryInput handleComplete={handleComplete} memberWeight={memberWeight} />
            <HistorySliderInput info={{ value: targetExercise.target_calory, title: '오늘의 목표 운동량을 입력하세요', unit: 'kcal', btnTitle: '목표 설정', max: 1000 }} handleComplete={saveTargetExercise} />
          </Grid>

          <Box sx={{ bgcolor: '#fff', p: '0 10px 10px 10px', borderRadius: '15px', boxShadow: '0px 2px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)' }}>
            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} sx={{ p: 1 }}>
              <Stack >
                <Typography component="div" sx={{ fontSize: 12, color: '#999', }}>최근 7일</Typography>
              </Stack>
              <Stack sx={{ ml: 'auto', zIndex: 2 }} >
                <Button sx={{ fontSize: 12, color: '#555', }} endIcon={<ArrowRightIcon />} >
                  월간현황
                </Button>
              </Stack>
            </Stack>
            <Divider />

            <Box sx={{
              mt: -3.5,
              '& .MuiBarElement-root': { fill: '#ff5454' },
              '& .MuiChartsLegend-mark': { fill: '#ff5454' }
            }}>
              <BarChart dataset={dataset}
                chartSetting={chartSet}
                series={series}
              />
            </Box>
          </Box>
        </Box>
      </Grid>

      <Bottom />
    </Stack>
  );
}

const chartSet = {
  xAxis: [
    {
      label: '',
    },
  ],
  maxWidth: 450,
  height: 300,
  slotProps: {
    legend: {
      direction: 'row',
      position: { vertical: 'bottom', horizontal: 'middle' },
      padding: -5,
      itemMarkWidth: 10,
      itemMarkHeight: 10,
      labelStyle: {
        fontSize: 12,
      },
    },
  },
};

export default HistoryBurnKcal;